import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { Button } from "../ui/button"
import { Badge } from "../ui/badge"
import { MapPin, Phone } from "lucide-react"

export default function Locationswidget() {

  const [data, setData] = useState(null)

  useEffect(() => {
    fetch("/wp-json/custom/v1/locations")
      .then(res => res.json())
      .then(res => setData(res))
  }, [])

  if (!data) return null

  return (
    <section className="py-12 bg-gray-100">
      <div className="container px-4 mx-auto">

        <div className="flex flex-col items-center mb-10 text-center">
          <Badge className="mb-2">Locations</Badge>

          <h2 className="mb-4 text-3xl font-bold md:text-4xl">
            {data.title}
          </h2>

          <p className="max-w-2xl text-[#485260]">
            {data.description}
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-4">

          {data.items?.map((item, index) => (
            <div key={index} className="bg-white rounded-lg overflow-hidden shadow-md">

             <img
                src={
                  (item.image?.url ||
                  item.image ||
                  "/placeholder.jpg").replace(/\.(png|jpe?g|gif|bmp|tiff?)$/i, ".webp")
                }
                alt={item.name}
                className="w-full h-48 object-cover"
              />

              <div className="p-4">

                <h3 className="text-xl font-bold">
                  {item.name}
                </h3>

                <div className="flex items-center gap-2 mt-2">
                  <MapPin className="w-4 h-4 text-primary" />
                  <span className="text-sm">{item.address}</span>
                </div>

                <div className="flex items-center gap-2 mt-2">
                  <Phone className="w-4 h-4 text-primary" />
                  <span className="text-sm">{item.phone}</span>
                </div>

                <div className="mt-4">
                  <Button variant="outline" size="sm" className="w-full" asChild>
                    <Link to={`/locations/${item.slug}`}>
                      View Details
                    </Link>
                  </Button>
                </div>

              </div>
            </div>
          ))}

        </div>

      </div>
    </section>
  )
}